import type { PricingOffer } from '../types';

export function formatUsd(cents: number): string {
  if (!Number.isSafeInteger(cents) || cents <= 0) throw new Error('Invalid server pricing offer.');
  return `$${(cents / 100).toFixed(2)}`;
}

export function pricingLabels(offer: PricingOffer): { currentPrice: string; referencePrice?: string; primaryCta: string; secondaryCta: string; stickyCta: string } {
  const currentPrice = formatUsd(offer.current_price_cents);
  const referencePrice = offer.show_reference_price && offer.reference_price_cents ? formatUsd(offer.reference_price_cents) : undefined;
  const cta = `Reveal My Next Six Months — ${currentPrice}`;
  return { currentPrice, ...(referencePrice ? { referencePrice } : {}), primaryCta: cta, secondaryCta:cta, stickyCta: cta };
}

export function pricingAnalyticsProperties(offer: PricingOffer): Record<string, string | number> {
  if (!offer.experiment_key || !offer.experiment_version || offer.variant.startsWith('standard_')) return {};
  return {
    experiment_key: offer.experiment_key,
    experiment_version: offer.experiment_version,
    experiment_variant: offer.variant,
    offered_price_cents: offer.current_price_cents,
    reference_price_cents: offer.reference_price_cents ?? 0,
    currency: offer.currency,
  };
}
